// Websocket通讯格式协议
export enum InteractiveMessageCode {
  // 客户端自定义的观看教程阶段
  SKYSHOT_JOURNEY_TUTORIAL = 'SKYSHOT_JOURNEY_TUTORIAL',
  // 客户端在任何情况需要同步服务端进程可以使用此代号
  // 客户端 >>> 服务端
  SKYSHOT_JOURNEY_SYNC_CONNECTION = 'SKYSHOT_JOURNEY_SYNC_CONNECTION',
  SKYSHOT_JOURNEY_SYNC_CONNECTION_REPLY = 'SKYSHOT_JOURNEY_SYNC_CONNECTION_REPLY',

  // 客户端在用户点击完成后发送完成教程代号通知服务端用户已完结教程可以开始飞行.
  // 客户端 >>> 服务端
  SKYSHOT_JOURNEY_TUTORIAL_COMPLETED = 'SKYSHOT_JOURNEY_TUTORIAL_COMPLETED',
  SKYSHOT_JOURNEY_TUTORIAL_COMPLETED_REPLY = 'SKYSHOT_JOURNEY_TUTORIAL_COMPLETED_REPLY',

  // 客户端连接长连接后应定频每10秒通知服务端客户端存活
  // 客户端 >>> 服务端
  SKYSHOT_JOURNEY_HEARTBEAT = 'SKYSHOT_JOURNEY_HEARTBEAT',
  SKYSHOT_JOURNEY_HEARTBEAT_REPLY = 'SKYSHOT_JOURNEY_HEARTBEAT_REPLY',

  // 客户端发送紧急降落命令
  // 客户端 >>> 服务端
  SKYSHOT_JOURNEY_EMERGENCY = 'SKYSHOT_JOURNEY_EMERGENCY',
  SKYSHOT_JOURNEY_EMERGENCY_REPLY = 'SKYSHOT_JOURNEY_EMERGENCY_REPLY',

  // 服务端 >>> 客户端
  /**
   * 无人机无法继续任务 -1
   */
  SKYSHOT_JOURNEY_INTERRUPTED = 'SKYSHOT_JOURNEY_INTERRUPTED',
  SKYSHOT_JOURNEY_INTERRUPTED_REPLY = 'SKYSHOT_JOURNEY_INTERRUPTED_REPLY',

  // 服务端 >>> 客户端
  /**
   * 通知客户端前置机直播推流失败 -7
   */
  SKYSHOT_JOURNEY_PUSH_LIVE_STREAM_FAILED = 'SKYSHOT_JOURNEY_PUSH_LIVE_STREAM_FAILED',
  SKYSHOT_JOURNEY_PUSH_LIVE_STREAM_FAILED_REPLY = 'SKYSHOT_JOURNEY_PUSH_LIVE_STREAM_FAILED_REPLY',

  // 服务端 >>> 客户端
  /**
   * 无人机正在执行任务 -200
   */
  SKYSHOT_JOURNEY_EXECUTING = 'SKYSHOT_JOURNEY_EXECUTING',
  SKYSHOT_JOURNEY_EXECUTING_REPLY = 'SKYSHOT_JOURNEY_EXECUTING_REPLY',

  // 服务端 >>> 客户端
  /**
   * 无人机电量不足 -207
   */
  SKYSHOT_JOURNEY_BATTERY_NOT_ENOUGH = 'SKYSHOT_JOURNEY_BATTERY_NOT_ENOUGH',
  SKYSHOT_JOURNEY_BATTERY_NOT_ENOUGH_REPLY = 'SKYSHOT_JOURNEY_BATTERY_NOT_ENOUGH_REPLY',

  // 服务端 >>> 客户端
  /**
   * 起飞指令参数不全 -208
   */
  SKYSHOT_JOURNEY_TAKEOFF_FAILED = 'SKYSHOT_JOURNEY_TAKEOFF_FAILED',
  SKYSHOT_JOURNEY_TAKEOFF_FAILED_REPLY = 'SKYSHOT_JOURNEY_TAKEOFF_FAILED_REPLY',

  // 服务端 >>> 客户端
  /**
   * 获取不到机场心跳 -209
   */
  SKYSHOT_JOURNEY_TAKEOFF_NO_HEARTBEAT = 'SKYSHOT_JOURNEY_TAKEOFF_NO_HEARTBEAT',
  SKYSHOT_JOURNEY_TAKEOFF_NO_HEARTBEAT_REPLY = 'SKYSHOT_JOURNEY_TAKEOFF_NO_HEARTBEAT_REPLY',

  // 服务端 >>> 客户端
  /**
   * 航线文件缺失 -210
   */
  SKYSHOT_JOURNEY_TAKEOFF_NO_FILE = 'SKYSHOT_JOURNEY_TAKEOFF_NO_FILE',
  SKYSHOT_JOURNEY_TAKEOFF_NO_FILE_REPLY = 'SKYSHOT_JOURNEY_TAKEOFF_NO_FILE_REPLY',

  // 服务端 >>> 客户端
  /**
   * 航线失败-无人机自动返航 -211
   */
  SKYSHOT_JOURNEY_AUTO_RETURN = 'SKYSHOT_JOURNEY_AUTO_RETURN',
  SKYSHOT_JOURNEY_AUTO_RETURN_REPLY = 'SKYSHOT_JOURNEY_AUTO_RETURN_REPLY',

  // 服务端 >>> 客户端
  /**
   * 恢复航线失败-结束航拍 -212
   */
  SKYSHOT_JOURNEY_RECOVERY_FAIL = 'SKYSHOT_JOURNEY_RECOVERY_FAIL',
  SKYSHOT_JOURNEY_RECOVERY_FAIL_REPLY = 'SKYSHOT_JOURNEY_RECOVERY_FAIL_REPLY',

  // 服务端 >>> 客户端
  /**
   * 有用户在飞行此条航线 -213
   */
  SKYSHOT_JOURNEY_THIS_LINE_FLYING = 'SKYSHOT_JOURNEY_THIS_LINE_FLYING',
  SKYSHOT_JOURNEY_THIS_LINE_FLYING_REPLY = 'SKYSHOT_JOURNEY_THIS_LINE_FLYING_REPLY',

  // 服务端 >>> 客户端
  /**
   * 机场未进行RTK标定
   */
  SKYSHOT_JOURNEY_NO_RTK = 'SKYSHOT_JOURNEY_NO_RTK',
  SKYSHOT_JOURNEY_NO_RTK_REPLY = 'SKYSHOT_JOURNEY_NO_RTK_REPLY',

  // 服务端 >>> 客户端
  /**
   * 未知错误 -***
   */
  SKYSHOT_JOURNEY_UNKNOWN = 'SKYSHOT_JOURNEY_UNKNOWN',
  SKYSHOT_JOURNEY_UNKNOWN_REPLY = 'SKYSHOT_JOURNEY_UNKNOWN_REPLY',

  // 服务端 >>> 客户端
  /**
   * 系统通知客户端机场无心跳
   */
  SKYSHOT_JOURNEY_DOCK_NO_HEARTBEAT = 'SKYSHOT_JOURNEY_DOCK_NO_HEARTBEAT',
  SKYSHOT_JOURNEY_DOCK_NO_HEARTBEAT_REPLY = 'SKYSHOT_JOURNEY_DOCK_NO_HEARTBEAT_REPLY',

  // 服务端 >>> 客户端
  /**
   * 系统通知客户端前置机无心跳
   */
  SKYSHOT_JOURNEY_AGENT_NO_HEARTBEAT = 'SKYSHOT_JOURNEY_AGENT_NO_HEARTBEAT',
  SKYSHOT_JOURNEY_AGENT_NO_HEARTBEAT_REPLY = 'SKYSHOT_JOURNEY_AGENT_NO_HEARTBEAT_REPLY',

  // 系统通知客户端自动退款
  // 服务端 >>> 客户端
  SKYSHOT_JOURNEY_AUTO_REFUND = 'SKYSHOT_JOURNEY_AUTO_REFUND',
  SKYSHOT_JOURNEY_AUTO_REFUND_REPLY = 'SKYSHOT_JOURNEY_AUTO_REFUND_REPLY',

  // 超时未起飞
  TAKE_OFF_TIME_OUT = 'TAKE_OFF_TIME_OUT',
  // 下发起飞指令失败
  START_FLY_CMD_FAIL = 'START_FLY_CMD_FAIL',
  // 无人机不在机舱内
  DRONE_NOT_IN_DOCK = 'DRONE_NOT_IN_DOCK',
  // 选择机场失败
  PICK_DOCK_FAIL = 'PICK_DOCK_FAIL',
  // 航线绑的前置机下查不到任何机场（mss-cloud#66）—— 配置问题，重试/改签都不会好
  SKYSHOT_JOURNEY_AGENT_DOCK_NOT_BOUND = 'SKYSHOT_JOURNEY_AGENT_DOCK_NOT_BOUND',
  // 机场在线但没关联无人机（mss-cloud#93）—— 同上，要运维去绑飞机
  SKYSHOT_JOURNEY_DOCK_DRONE_NOT_BOUND = 'SKYSHOT_JOURNEY_DOCK_DRONE_NOT_BOUND',
  // 机场正在拉取日志中，无法执行飞行任务"
  DJI_UPLOAD_LOG = 'DJI_UPLOAD_LOG',
  // 未完成启动 订单超出预定时间
  NOT_COMPLETE_START = 'NOT_COMPLETE_START',
  // 启动订单状态错误
  START_ORDER_STATUS_ERROR = 'START_ORDER_STATUS_ERROR',
  // 订单预定时间未到
  BEFORE_SCHEDULED_TIME = 'BEFORE_SCHEDULED_TIME',
  // 1. 设备端通知服务端已打开直播(推流)，服务端通知客户端打开直播(拉流)。live: on
  // 2. 服务端通知客户端通知关闭直播。 live: off
  // 服务端 >>> 客户端
  SKYSHOT_JOURNEY_LIVE = 'SKYSHOT_JOURNEY_LIVE',
  SKYSHOT_JOURNEY_LIVE_REPLY = 'SKYSHOT_JOURNEY_LIVE_REPLY',

  // 系统通知客户端无人机开始起飞
  // 服务端 >>> 客户端
  SKYSHOT_JOURNEY_START_FLIGHT = 'SKYSHOT_JOURNEY_START_FLIGHT',
  SKYSHOT_JOURNEY_START_FLIGHT_REPLY = 'SKYSHOT_JOURNEY_START_FLIGHT_REPLY',

  // 系统通知客户端无人机到达起飞点
  // 服务端 >>> 客户端
  SKYSHOT_JOURNEY_TAKEOFF = 'SKYSHOT_JOURNEY_TAKEOFF',
  SKYSHOT_JOURNEY_TAKEOFF_REPLY = 'SKYSHOT_JOURNEY_TAKEOFF_REPLY',

  // 系统通知超过了最大高度飞行范围
  SKYSHOT_JOURNEY_DRC_OUT_MAX_H = 'SKYSHOT_JOURNEY_DRC_OUT_MAX_H', // 飞行操作-超过了最大高度飞行范围
  SKYSHOT_JOURNEY_DRC_OUT_MIN_H = 'SKYSHOT_JOURNEY_DRC_OUT_MIN_H', // 飞行操作-超过了最小高度飞行范围
  SKYSHOT_JOURNEY_DRC_OUT_MAX_X = 'SKYSHOT_JOURNEY_DRC_OUT_MAX_X', // 飞行操作-超过了往前的最大飞行范围
  SKYSHOT_JOURNEY_DRC_OUT_MIN_X = 'SKYSHOT_JOURNEY_DRC_OUT_MIN_X', // 飞行操作-超过了往后的最大飞行范围
  SKYSHOT_JOURNEY_DRC_OUT_MAX_Y = 'SKYSHOT_JOURNEY_DRC_OUT_MAX_Y', // 飞行操作-超过了往右的最大飞行范围
  SKYSHOT_JOURNEY_DRC_OUT_MIN_Y = 'SKYSHOT_JOURNEY_DRC_OUT_MIN_Y', // 飞行操作-超过了往左的最大飞行范围

  // 1. 服务端通知客户端开始拍照时间。switch: on
  // 2. 服务端通知客户端结束拍照时间。switch: off
  // 服务端 >>> 客户端
  SKYSHOT_JOURNEY_PHOTO_TIME = 'SKYSHOT_JOURNEY_PHOTO_TIME',
  SKYSHOT_JOURNEY_PHOTO_TIME_REPLY = 'SKYSHOT_JOURNEY_PHOTO_TIME_REPLY',

  // 1. 服务端通知客户端开始航拍。有data则表示开始航拍
  // 2. 服务端通知客户端结束航拍。无data则表示结束航拍
  // 服务端 >>> 客户端
  SKYSHOT_JOURNEY_SKYSHOT = 'SKYSHOT_JOURNEY_SKYSHOT',
  SKYSHOT_JOURNEY_SKYSHOT_REPLY = 'SKYSHOT_JOURNEY_SKYSHOT_REPLY',

  // 1. 系统通知客户端无人机打开 DRC。switch: 'on'
  // 2. 系统通知客户端无人机关闭 DRC。switch: 'off'
  // 服务端 >>> 客户端
  SKYSHOT_JOURNEY_DRC_ON = 'SKYSHOT_JOURNEY_DRC_ON',
  SKYSHOT_JOURNEY_DRC_OFF = 'SKYSHOT_JOURNEY_DRC_OFF',
  SKYSHOT_JOURNEY_DRC_REPLY = 'SKYSHOT_JOURNEY_DRC_REPLY',

  // 客户端通知服务端用户在 DRC 期间操作, 服务器再回复
  // 客户端 >>> 服务端
  SKYSHOT_JOURNEY_DRC_ACTION = 'SKYSHOT_JOURNEY_DRC_ACTION',
  SKYSHOT_JOURNEY_DRC_ACTION_REPLY = 'SKYSHOT_JOURNEY_DRC_ACTION_REPLY',

  // 服务端通知客户端更新航点
  // 服务端 >>> 客户端
  SKYSHOT_JOURNEY_WAYPOINT = 'SKYSHOT_JOURNEY_WAYPOINT',
  SKYSHOT_JOURNEY_WAYPOINT_REPLY = 'SKYSHOT_JOURNEY_WAYPOINT_REPLY',

  // 服务端通知客户端飞行已完结
  // 服务端 >>> 客户端
  SKYSHOT_JOURNEY_END = 'SKYSHOT_JOURNEY_END',
  SKYSHOT_JOURNEY_END_REPLY = 'SKYSHOT_JOURNEY_END_REPLY',

  // 服务端通知客户端设备配置已准备
  // 服务端 >>> 客户端
  SKYSHOT_JOURNEY_READY = 'SKYSHOT_JOURNEY_READY',
  SKYSHOT_JOURNEY_READY_REPLY = 'SKYSHOT_JOURNEY_READY_REPLY',

  // 服务端通知客户端服务不可用
  // 服务端 >>> 客户端
  SKYSHOT_JOURNEY_SERVICE_NOT_AVAILABLE = 'SKYSHOT_JOURNEY_SERVICE_NOT_AVAILABLE',

  // 服务端通知客户端 DRC 动作执行结果, 成功结果对应数据字段为真 true，失败结果为假 false,
  // 服务端 >>> 客户端
  SKYSHOT_JOURNEY_DRC_ACTION_RESULT = 'SKYSHOT_JOURNEY_DRC_ACTION_RESULT',

  // 服务端通知客户端直播连接中断
  SKYSHOT_JOURNEY_LIVE_STREAM_FAILED = 'SKYSHOT_JOURNEY_LIVE_STREAM_FAILED',
  SKYSHOT_JOURNEY_LIVE_STREAM_FAILED_REPLY = 'SKYSHOT_JOURNEY_LIVE_STREAM_FAILED_REPLY',

  // 通知服务端直播拉流失败
  // 客户端 >>> 服务端
  SKYSHOT_JOURNEY_PULL_LIVE_STREAM_FAILED = 'SKYSHOT_JOURNEY_PULL_LIVE_STREAM_FAILED',
  SKYSHOT_JOURNEY_PULL_LIVE_STREAM_FAILED_REPLY = 'SKYSHOT_JOURNEY_PULL_LIVE_STREAM_FAILED_REPLY',

  // 通知客户端无人机开启 DRC 失败
  // 服务端 >>> 客户端
  SKYSHOT_JOURNEY_TURN_DRC_ON_FAILED = 'SKYSHOT_JOURNEY_TURN_DRC_ON_FAILED',
  SKYSHOT_JOURNEY_DRC_INIT_FAILED = 'SKYSHOT_JOURNEY_DRC_INIT_FAILED',

  // DroneGoHome: 无人机返航
  SKYSHOT_JOURNEY_GO_HOME = 'SKYSHOT_JOURNEY_GO_HOME',
  // DroneLanding: 无人机降落
  SKYSHOT_JOURNEY_LANDING = 'SKYSHOT_JOURNEY_LANDING',

  // 通知客户端航线流程改变
  SKYSHOT_JOURNEY_ROUTE_CHANGE = 'SKYSHOT_JOURNEY_ROUTE_CHANGE',
  SKYSHOT_JOURNEY_ROUTE_CHANGE_REPLY = 'SKYSHOT_JOURNEY_ROUTE_CHANGE_REPLY',
  // 表示服务器没记录任何动作
  SKYSHOT_JOURNEY_NO_SERVER_WILL = 'SKYSHOT_JOURNEY_NO_SERVER_WILL',
  // 服务端通知客户端飞行权限状态
  FLY_OPT_AUTH_STATE = 'FLY_OPT_AUTH_STATE',
  // 客户端请求服务端飞行权限
  REQUEST_FLY_OPT_AUTH = 'REQUEST_FLY_OPT_AUTH',
  // 服务端通知客户端选择哪个机场
  SKYSHOT_JOURNEY_PICK_DOCK = 'SKYSHOT_JOURNEY_PICK_DOCK',
  // 服务端通知客户端无人机启动
  SKYSHOT_JOURNEY_DRONE_STARTUP = 'SKYSHOT_JOURNEY_DRONE_STARTUP',
  // 服务端通知客户端机场舱盖打开
  SKYSHOT_JOURNEY_DOCK_COVER_OPEN = 'SKYSHOT_JOURNEY_DOCK_COVER_OPEN',
  // 服务端通知客户端无人机OSD
  SKYSHOT_JOURNEY_DRONE_OSD = 'SKYSHOT_JOURNEY_DRONE_OSD',
  // 服务端通知客户端拍照成功
  SKYSHOT_JOURNEY_PHOTO_SHOT_SUCCESS = 'SKYSHOT_JOURNEY_PHOTO_SHOT_SUCCESS',
  // 服务端通知客户端拍照失败
  SKYSHOT_JOURNEY_PHOTO_SHOT_FAILED = 'SKYSHOT_JOURNEY_PHOTO_SHOT_FAILED',
  // 服务端通知客户端录影应答
  SKYSHOT_JOURNEY_FLY_RECORD = 'SKYSHOT_JOURNEY_FLY_RECORD',
  // 航线在录制视频,用户不能手动开启录影
  AIRLINE_IN_RECORDING = 'AIRLINE_IN_RECORDING',
  // 设置直播清晰度成功
  LIVE_QUALITY_SUCCESS = 'LIVE_QUALITY_SUCCESS',
  // 设置直播清晰度失败
  LIVE_QUALITY_FAIL = 'LIVE_QUALITY_FAIL',
}

export enum ServerCallCode {
  // LiveStreamPushed: 前置机已推流
  SKYSHOT_JOURNEY_LIVE = 'SKYSHOT_JOURNEY_LIVE',
  // StartFlight: 前置机开始起飞
  SKYSHOT_JOURNEY_START_FLIGHT = 'SKYSHOT_JOURNEY_START_FLIGHT',
  // TakeOff: 无人机到达起航点
  SKYSHOT_JOURNEY_TAKEOFF = 'SKYSHOT_JOURNEY_TAKEOFF',
  // DRC_ON: 开始航点操作
  SKYSHOT_JOURNEY_DRC_ON = 'SKYSHOT_JOURNEY_DRC_ON',
  // DRC_OFF: 结束航点操作
  SKYSHOT_JOURNEY_DRC_OFF = 'SKYSHOT_JOURNEY_DRC_OFF',
  // PhotoTime: 拍照时间
  SKYSHOT_JOURNEY_PHOTO_TIME = 'SKYSHOT_JOURNEY_PHOTO_TIME',
  // DroneGoHome: 无人机返航
  SKYSHOT_JOURNEY_GO_HOME = 'SKYSHOT_JOURNEY_GO_HOME',
  // DroneLanding: 无人机降落
  SKYSHOT_JOURNEY_LANDING = 'SKYSHOT_JOURNEY_LANDING',
  // LiveStreamFailed: 前置机推流失败
  SKYSHOT_JOURNEY_LIVE_STREAM_FAILED = 'SKYSHOT_JOURNEY_LIVE_STREAM_FAILED',
  // End: 旅程结束
  SKYSHOT_JOURNEY_END = 'SKYSHOT_JOURNEY_END',
}

export enum ClientCallCode {
  SKYSHOT_JOURNEY_TUTORIAL_COMPLETED = 'SKYSHOT_JOURNEY_TUTORIAL_COMPLETED',
  SKYSHOT_JOURNEY_EMERGENCY = 'SKYSHOT_JOURNEY_EMERGENCY',
  SKYSHOT_JOURNEY_LIVE_REPLY = 'SKYSHOT_JOURNEY_LIVE_REPLY',
  SKYSHOT_JOURNEY_END = 'SKYSHOT_JOURNEY_END',
}

// 前端过滤后需要接收的Code
// export enum JourneyCode {
//     // 观看教程完成回复
//     SKYSHOT_JOURNEY_TUTORIAL_COMPLETED_REPLY = InteractiveMessageCode.SKYSHOT_JOURNEY_TUTORIAL_COMPLETED_REPLY,
//     // 直播
//     SKYSHOT_JOURNEY_START_LIVE = InteractiveMessageCode.SKYSHOT_JOURNEY_LIVE,
//     // 开始起飞
//     SKYSHOT_JOURNEY_START_FLIGHT = InteractiveMessageCode.SKYSHOT_JOURNEY_START_FLIGHT,
//     // 到达起飞点
//     SKYSHOT_JOURNEY_TAKEOFF = InteractiveMessageCode.SKYSHOT_JOURNEY_TAKEOFF,
//     // 拍照
//     SKYSHOT_JOURNEY_PHOTO_TIME = InteractiveMessageCode.SKYSHOT_JOURNEY_PHOTO_TIME,
//     // DRC 开始
//     SKYSHOT_JOURNEY_DRC_ON = InteractiveMessageCode.SKYSHOT_JOURNEY_DRC_ON,
//     // DRC 结束
//     SKYSHOT_JOURNEY_DRC_OFF = InteractiveMessageCode.SKYSHOT_JOURNEY_DRC_OFF,
//     // 航拍
//     SKYSHOT_JOURNEY_SKYSHOT = InteractiveMessageCode.SKYSHOT_JOURNEY_SKYSHOT,
//     // 旅程结束
//     SKYSHOT_JOURNEY_END = InteractiveMessageCode.SKYSHOT_JOURNEY_END,
//     // 表示服务器没记录任何动作
//     SKYSHOT_JOURNEY_NO_SERVER_WILL = InteractiveMessageCode.SKYSHOT_JOURNEY_NO_SERVER_WILL,
// }

// 前端自定义旅程步骤
export enum JourneyStep {
  // 客户端自定义的观看教程阶段
  SKYSHOT_JOURNEY_TUTORIAL = InteractiveMessageCode.SKYSHOT_JOURNEY_TUTORIAL,
  // 观看教程完成回复
  SKYSHOT_JOURNEY_TUTORIAL_COMPLETED_REPLY = InteractiveMessageCode.SKYSHOT_JOURNEY_TUTORIAL_COMPLETED_REPLY,
  // 开始直播
  SKYSHOT_JOURNEY_START_LIVE = 'SKYSHOT_JOURNEY_START_LIVE',
  // 正在起飞
  SKYSHOT_JOURNEY_START_FLIGHT = InteractiveMessageCode.SKYSHOT_JOURNEY_START_FLIGHT,
  // 到达起飞点
  SKYSHOT_JOURNEY_TAKEOFF = InteractiveMessageCode.SKYSHOT_JOURNEY_TAKEOFF,
  // 拍照开始
  SKYSHOT_JOURNEY_PHOTO_TIME_START = 'SKYSHOT_JOURNEY_PHOTO_TIME_START',
  // 拍照结束
  SKYSHOT_JOURNEY_PHOTO_TIME_END = 'SKYSHOT_JOURNEY_PHOTO_TIME_END',
  // DRC开始
  SKYSHOT_JOURNEY_DRC_ON = InteractiveMessageCode.SKYSHOT_JOURNEY_DRC_ON,
  // DRC结束
  SKYSHOT_JOURNEY_DRC_OFF = InteractiveMessageCode.SKYSHOT_JOURNEY_DRC_OFF,
  // 航拍开始
  SKYSHOT_JOURNEY_SKYSHOT_START = 'SKYSHOT_JOURNEY_SKYSHOT_START',
  // 航拍结束
  SKYSHOT_JOURNEY_SKYSHOT_END = 'SKYSHOT_JOURNEY_SKYSHOT_END',
  // 无人机返航
  SKYSHOT_JOURNEY_GO_HOME = InteractiveMessageCode.SKYSHOT_JOURNEY_GO_HOME,
  // 无人机降落
  SKYSHOT_JOURNEY_LANDING = InteractiveMessageCode.SKYSHOT_JOURNEY_LANDING,
  // 旅程结束
  SKYSHOT_JOURNEY_END = InteractiveMessageCode.SKYSHOT_JOURNEY_END,
}

export type Switch = 'on' | 'off'
export interface DroneControlData {
  seq?: number
  x?: number
  y?: number
  h?: number
  w?: number
  altitude?: number
}

export interface DroneControlFences {
  x: -1 | 0 | 1
  y: -1 | 0 | 1
  h: -1 | 0 | 1
}

export type PhotoTimeType = 'system' | 'user'
export interface LiveData {
  switch: Switch
  channel: string
  access_token: string
  uid: number
}

export interface FlyHeight {
  index: number
  fly_up: number
  fly_down: number
}

export interface AgoraData {
  uid: number
  channel: string
  token: string
  expiredAt: string
}

export interface PhotoData {
  count: number
  /**
   * 可拍照数量
   * 0 不可拍照
   * -1 不限制拍照
   * 其他 限制拍照
   */
  total: number
  success: number
  failed: number
  /**
   * 点击拍照次数
   */
  clickCount: number
}

export interface UserPause {
  /**
   * 是否允许暂停
   */
  pauseSwitchState: boolean
  /**
   * 单位：秒
   */
  time: string
}

export interface SyncConnectionData {
  /**
   * 目前航点
   */
  waypoint: number
  /**
   * 目前进度
   */
  progress: number
  /**
   * 是否完成
   */
  is_ended: boolean
  /**
   * 完成教程时间
   */
  is_started: string
  /**
   * 直播推流时间
   */
  is_live_pushed: string
  /**
   * 声网凭证
   */
  agora: AgoraData
  photo: PhotoData
  /**
   * 航线流程
   */
  wayline_process: NodalStep[]
  /**
   * 当前节点
   */
  current_nodal: NodalStep
  /**
   * 控飞高度范围
   */
  fly_heights: FlyHeight[]
  /**
   * 无人机高度
   */
  altitude: number
  /**
   * 表示客户端最后发出指令时间
   */
  client_last_call_time: string
  /**
   * 这个字段表示客户端最后发出的指令
   */
  client_call: WebsocketCommunicationFormat<any, ClientCallCode>
  /**
   * 表示服务端最后发出指令时间
   */
  server_last_call_time: string
  /**
   * 这个字段表示服务端最新发出的指令
   */
  server_call: WebsocketCommunicationFormat<any, ServerCallCode>

  recordInfo: RecordInfo

  /**
   * 航线动作类型
   * 系统拍照 1
   * 用户拍照 2
   * 用户控飞 3
   */
  airlineActionType: number
  /**
   * 用户暂停
   */
  userPause: UserPause
  /**
   * 起飞时间
   */
  isStartedTime: number | string
  /**
   * 控飞时间，单位秒 小于等于0则不限时长
   */
  opFlyTime: number
}

export interface StartTakePhotoData {
  /**
   * 开关
   */
  switch: Switch
  /**
   * 开始或结束时间 timestamp
   */
  start_or_end: string
  /**
   * 时长, 单位是秒
   */
  length: number
  /**
   * 类型
   */
  type: PhotoTimeType
}

export interface StartSkyshotData {
  /**
   * 开关
   */
  switch: Switch
  /**
   * 开始时间 timestamp
   */
  skyshot_start_time?: number | string
  /**
   * 时长, 单位是秒
   */
  skyshot_time_length?: number | string
}

export interface WaypointData {
  /**
   * 目前航点
   */
  waypoint: number
  /**
   * 目前进度
   */
  progress: number
  /**
   * 是否完成
   */
  completed: boolean
}

export interface DRCaction {
  /**
   * 云台转向
   */
  gimbal?: {
    pitch: number
    yaw: number
  }
  /**
   * 相机缩放
   */
  zoom?: number
  /**
   * 自拍
   */
  selfie?: Switch | 'triple'
  /**
   * 大师角度预设
   */
  preset?: number
  /**
   * 飞行控制
   */
  drone_control?: DroneControlData
}

export interface DRCData {
  /**
   * 开关
   */
  switch: Switch
  /**
   * 暂停次数
   */
  index: number
  /**
   * 自拍
   */
  photograph: Switch
  /**
   * 录影
   */
  video: Switch
  /**
   * 控制镜头焦距
   */
  cameraForcalSet: Switch
  /**
   * 转动云台
   */
  controlCamera: Switch
  /**
   * 控制飞行
   */
  userFly: Switch
  /**
   * 结束时间 单位是秒
   */
  finish: number
  /**
   * on开始时间
   */
  timestamp: string

  /**
   * 录像状态: 'on' 开启录像, 'off' 停止录像
   */
  record: Switch
  /**
   * 可拍照数量
   * 0 不可拍照
   * -1 不限制拍照
   * 其他 限制拍照
   */
  photographSum: number

  /**
   * 拍照数量
   */
  total: number

  /**
   * 录影信息
   */
  recordInfo: RecordInfo
  /**
   * 暂停类型
   * undefined表示未暂停
   * 0表示航线暂停
   * 1表示用户暂停
   */
  pauseType: number | undefined
}

export interface DroneOSD {
  /**
   * 信号质量
   */
  quality: number
  /**
   * 卫星数量
   */
  rtkNumber: number
  /**
   * 电量
   */
  capacityPercent: number
  /**
   * 飞行高度
   */
  height: number
  /**
   * 距离home点距离
   */
  homeDistance: number
  /**
   * 水平速度
   */
  horizontalSpeed: number
  /**
   * 垂直速度
   */
  verticalSpeed: number
  /**
   * 收敛状态
   * 0 未开始
   * 1 收敛中
   * 2 收敛成功
   * 3 收敛失败
   */
  isFixed: number
}

export enum StepNodal {
  /**
   * 前端的
   */
  TAKE_OFF = 'TAKE_OFF',

  /**
   * 前端的
   */
  GO_HOME = 'GO_HOME',

  /**
   * 录影
   */
  RECORDING = 'RECORDING',

  /**
   * 自拍/控飞
   */
  USER_PHOTO = 'USER_PHOTO',

  /**
   * 控飞
   */
  CONTROL = 'CONTROL',

  /**
   * 系统拍照
   */
  SYSTEM_PHOTO = 'SYSTEM_PHOTO',

  /**
   * 航行
   */
  FLYING = 'FLYING',

  /**
   * 悬停控飞
   */
  HOVERING_CONTROL = 'HOVERING_CONTROL',
}

export interface DroneSignal {
  quality: number
  rtkNumber: number
  isFixed: boolean
}

export interface FlyRecord {
  /** 录像状态: 'on' 开启录像, 'off' 停止录像 */
  record: Switch
  /** 操作是否成功 */
  success: boolean
  /** 录像相关信息 */
  recordInfo: RecordInfo
}

export interface RecordInfo {
  /** 录像时间配置，单位秒。-1表示无限制，0表示不录像，90表示录像90秒 */
  durationSeconds: number
  /** 历史已录像时间，单位秒 */
  completedSeconds: number
  /** 当前录像开始时间，时间戳 */
  startTime: number
  /** 当前时间，时间戳 */
  currentTime: number
}

export enum FlyTaskStatus {
  // 通知航线启动失败 剩下大于1分钟的启动时间
  SKYSHOT_JOURNEY_MORE_THAN_ONE_MINUTE_FAILED = 'SKYSHOT_JOURNEY_MORE_THAN_ONE_MINUTE_FAILED',
  // 通知航线启动失败 剩下小于1分钟的启动时间
  SKYSHOT_JOURNEY_LESS_THAN_ONE_MINUTE_FAILED = 'SKYSHOT_JOURNEY_LESS_THAN_ONE_MINUTE_FAILED',
}

export interface JourneyFailed {
  flyTaskStatus: FlyTaskStatus
  [key: string]: any
}

export interface NodalStep<T = number> {
  index: T
  nodal: string | StepNodal
  [key: string]: any
}

// 录影模式枚举
export enum RecordingMode {
  DISABLED = 'disabled', // 禁用
  LIMITED = 'limited', // 限制时长模式（递减）
  UNLIMITED = 'unlimited', // 无限制模式（累加）
}

// 拍照模式枚举
export enum PhotoMode {
  UNLIMITED = 'unlimited', // 无限拍
  LIMITED = 'limited', // 限制拍照
}

export const TAKE_OFF = {
  index: 0,
  nodal: 'TAKE_OFF',
} as NodalStep

export const DRONE_STARTUP = {
  index: -1,
  nodal: 'DRONE_STARTUP',
} as NodalStep

export const DOCK_COVER_OPEN = {
  index: -2,
  nodal: 'DOCK_COVER_OPEN',
} as NodalStep

export const PREPARE_FOR_TAKE_OFF = {
  index: -3,
  nodal: 'PREPARE_FOR_TAKE_OFF',
} as NodalStep

export const GO_HOME = {
  index: 1000,
  nodal: 'GO_HOME',
} as NodalStep

export interface SendFlyTaskResponse {
  /**
   * 业务状态码
   */
  bizCode?: any
  /**
   * 消息状态码
   */
  code?: number
  /**
   * 数据对象
   */
  data?: { [key: string]: any }
  /**
   * 消息内容
   */
  msg?: string
  [property: string]: any
}

export interface WebsocketCommunicationFormat<T = any, P = InteractiveMessageCode> {
  code: P
  timestamp: string | number
  ticketId: string
  data: T
}

export enum LiveQuality {
  AUTO = 0,
  SMOOTH = 1,
  STANDARD = 2,
  HD = 3,
  UHD = 4,
}

export const websocketCommunicationFormat = <T = any>(
  code: InteractiveMessageCode,
  ticketId: string,
  data?: T,
) => {
  return JSON.stringify({
    code,
    ticketId,
    timestamp: new Date().getTime(),
    data,
  } as WebsocketCommunicationFormat<T>)
}
